import { useState } from 'react';
import {
  getPrizeTierByValue,
  LottoPrizeValueFilterOptions,
} from 'constants/LottoPrizeValues';
import Chevron from 'components/Chevron';
import PrizeTierBadgeAndTitle, {
  Size,
} from 'components/prizes/PrizeValueDropdownSelector/PrizeTierBadgeAndTitle';
import React from 'react';


export const roughValueComponent = (
  solidPoundSignString: string,
  fadedPoundSignString: string
) => (
  <p>
    {solidPoundSignString}
    <span style={{ opacity: 0.5 }}>{fadedPoundSignString}</span>
  </p>
);

const OPTIONS = [
  {
    titleComponent: (
      <p
        style={{
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '1.1rem',
          margin: 0,
        }}
      >
        View All
      </p>
    ),
    roughValueComponent: roughValueComponent('£ - £££££', ''),
    value: null,
  },
  ...LottoPrizeValueFilterOptions.map((value) => {
    const prizeInfo = getPrizeTierByValue(value);
    const { title, subtitle, badge, poundSigns } = prizeInfo!;
    return {
      titleComponent: (
        <PrizeTierBadgeAndTitle
          title={title}
          subtitle={subtitle}
          badge={badge}
          size={Size.COMPACT}
        />
      ),
      roughValueComponent: roughValueComponent(
        poundSigns.solid,
        poundSigns.faded
      ),
      value,
    };
  }),
];


interface IPrizeValueDropdownSelectorProps { 
  value: number | null
  onChange: (value: number | null) => void
  style?: React.CSSProperties
}

const PrizeValueDropdownSelector = ({
  value,
  onChange,
  style = undefined,
}: IPrizeValueDropdownSelectorProps) => {
  const [expanded, setExpanded] = useState(false);

  // First row is always shown
  const renderFirstRowLeftSide = () => {
    if (expanded || !value)
      return (
        <p
          style={{
            margin: 0,
            fontSize: "1.1rem",
            color: "#9B9B9B",
          }}
        >
          Filter by prize tier
        </p>
      );

    const { title, subtitle, badge } = getPrizeTierByValue(value)!;

    return (
      <PrizeTierBadgeAndTitle
        title={title}
        subtitle={subtitle}
        badge={badge}
        size={Size.COMPACT}
      />
    );
  };

  return (
    <div
      className={`prizeValueDropdownSelectorContainer p-0 ${
        expanded ? "!border-white" : ""
      }`}
      style={style}
    >
      <div
        className={`firstRow p-6 ${
          expanded ? "p-6 rounded-t-[25px]" : " rounded-[30px]"
        }`}
        style={
          expanded
            ? {
                height: "40px",
                boxShadow: "0px 3px 100px 0px rgba(0, 0, 0, 0.4)",
              }
            : {}
        }
        onClick={() => setExpanded(!expanded)}
      >
        {renderFirstRowLeftSide()}

        <Chevron
          direction="down"
          reversed={expanded}
          style={{ color: "#AAA" }}
        />
      </div>

      {expanded && (
        <div
          className="dropdownMenu p-3 rounded-b-[30px] hover:cursor-pointer"
          style={{
            width: "100%",
            background: "white",
            position: "absolute",
            zIndex: 1,
            boxShadow: expanded
              ? "0px 50px 50px -1px rgba(0, 0, 0, 0.4)"
              : "none",
          }}
        >
          {OPTIONS.sort((a, b) => (a.value || 0) - (b.value || 0)).map((option, index) => {
            return (
              <div
                key={option.value ?? "null"}
                style={{
                  borderColor: "#E1E1E1",
                }}
                className={`${
                  index !== OPTIONS.length - 1
                    ? "border border-solid border-2 border-t-0 border-x-0"
                    : ""
                } p-2`}
              >
                <div
                  style={
                    option.value === value ? { background: "#F6F6F6" } : {}
                  }
                  className={"px-4 hoverColor !rounded-lg dropdownRow"}
                  onClick={() => {
                    onChange(option.value);
                    setExpanded(false);
                  }}
                >
                  {option.titleComponent}

                  {option.roughValueComponent}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <style jsx>
        {`
          .prizeValueDropdownSelectorContainer {
            border: 2px solid #e1e1e1;
            border-radius: 35px;
            width: 100%;
            isolation: isolate;
            z-index: 1;
            font-family: Montserrat-SemiBold, Montserrat, sans-serif;
            position: relative;
          }

          .hoverColor:hover {
            background-color: #f6f6f6;
          }

          .firstRow {
            height: 40px;
          }

          .firstRow,
          .dropdownRow {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .dropdownRow {
            transition: 0.2s;
            min-height: 40px;
          }
        `}
      </style>
    </div>
  );
};

export default PrizeValueDropdownSelector;
